(function () {
  function handleBestSeller() {
    const tagHolder = document.getElementById('product-tags');
    if (!tagHolder) return;
    const tags = tagHolder.dataset.tags || '';
    const hasBestSeller = tags.includes('best-seller');
    const buttons = document.querySelectorAll('[data-class="best-seller-btn"]');
    if (hasBestSeller) {

      buttons.forEach(el => {
        el.style.setProperty('display', 'block', 'important');
      });
    } else {
      buttons.forEach(el => el.remove());
    }
  }

  let tries = 0;
  const interval = setInterval(() => {
    handleBestSeller();
    tries++;
    if (tries > 40) clearInterval(interval);
  }, 200);
  const observer = new MutationObserver(() => {
    handleBestSeller();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();